/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'bot-detection-policy';
const componentName = 'bot-detection-policy-item';
const prefix = `${moduleName}.${componentName}`;

export const botManagementPolicyBreadcrumbTitle = `${prefix}.botManagementPagePolicyTitle`;

export const ENGLISH = {
    [botManagementPolicyBreadcrumbTitle]: 'Bot Management Policy',
};
